import type { RouteRecordRaw } from 'vue-router';

export const employeesRoutes: RouteRecordRaw[] = [
  {
    path: 'employees',
    name: 'employees',
    component: () => import('./pages/EmployeesListPage.vue'),
    meta: { title: 'Employees', requiresAuth: true, permission: 'view_employees' },
  },
  {
    path: 'employees/:id',
    name: 'employees.show',
    component: () => import('./pages/EmployeeDetailPage.vue'),
    meta: { title: 'Employee', requiresAuth: true },
  },
];
